export class FloorTowerModel {
    constructor(public id: string, public name: string) {}
}